import { AppInjector } from './../../app-injector';
import { ApiUrl } from './../api-url.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceProvider } from '../service.provider';
import { Observable } from 'rxjs/Observable';
import { tap, catchError, map } from 'rxjs/operators';
import Collection from '../../models/Collection';
import { PreloaderService } from '../../common/services/preloader/preloader.service';
import CollectionSummary from "../../models/CollectionSummary";

@Injectable()
export class CollectionService extends ServiceProvider {

  protected url = '/api/v1/collections';

  constructor(
  ) {
    super(
      AppInjector.get(HttpClient),
      AppInjector.get(ApiUrl),
      'Collection'
    );
  }

  getItemByIdWithProducts(id): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.get(`${this.apiUrl.getApiUrl(this.url)}/${id}`).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result => new Collection((result as any).data)),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  getSummary(): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.get(`${this.apiUrl.getApiUrl(this.url)}/summary`).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result => new CollectionSummary((result as any).data)),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  attachProduct(id, data): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(`${this.apiUrl.getApiUrl(this.url)}/${id}/product`, data).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result => new Collection((result as any).data)),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  addBag(bag): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(`${this.apiUrl.getApiUrl(this.url)}/bag/${bag}`, {}).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  sendConsigmentAgreement(collectionId): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(`${this.apiUrl.getApiUrl(this.url)}/${collectionId}/agreement`, {}).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result => new Collection((result as any).data)),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  sendPickupConfirmation(collectionId): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(`${this.apiUrl.getApiUrl(this.url)}/${collectionId}/pickupconfirmation`, {}).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result => new Collection((result as any).data)),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  sendCollectionToShoot(collectionId): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(`${this.apiUrl.getApiUrl(this.url)}/${collectionId}/pricecomplete`, {}).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result => new Collection((result as any).data)),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  sendCollectionToWarehouse(collectionId): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(`${this.apiUrl.getApiUrl(this.url)}/${collectionId}/arrived`, {}).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result => new Collection((result as any).data)),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  responseCollection(collectionId, response, fasttrack): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(`${this.apiUrl.getApiUrl(this.url)}/${collectionId}/respond`, {response, fasttrack}).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result => new Collection((result as any).data)),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }
}
